<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <bita-ibox :is-loading="isLoading">
        <div slot="body">
          <form-wizard
            ref="wizard"
            title
            subtitle
            next-button-text="مرحله بعد"
            back-button-text="مرحله قبل"
            finish-button-text="پایان"
            color="#1ab394"
            shape="circle"
            @on-complete="onComplete"
          >
            <tab-content
              title="اطلاعات"
              icon="fab fa-product-hunt"
              :before-change="() => validateInfo('infoForm', 'variantsForm')"
            >
              <product-info-form
                ref="infoForm"
                :product="createdProduct"
                @on-update="(e) => (createdProduct = e)"
                @is-loading="(e) => (isLoading = e)"
              />
            </tab-content>
            <tab-content
                title="نسخه ها"
                icon="fas fa-dollar-sign"
                :before-change="() => validateInfo('variantsForm', 'imageForm')"
            >
              <product-variants
                  ref="variantsForm"
                  @is-loading="(e) => (isLoading = e)"
              />
            </tab-content>
            <!-- <tab-content
              title="ویژگی ها"
              icon="fas fa-info-circle"
              :before-change="() => validateInfo('detailForm', 'imageForm')"
            >
              <product-detail-form
                ref="detailForm"
                @is-loading="(e) => (isLoading = e)"
              />
            </tab-content> -->
            <!-- <tab-content
              title="اطلاعات"
              icon="fas fa-info"
              :before-change="() => validateInfo('featureForm', 'imageForm')"
            >
              <product-feature-form
                ref="featureForm"
                @is-loading="(e) => (isLoading = e)"
              />
            </tab-content> -->
            <tab-content
              title="تصاویر"
              icon="fas fa-images"
              :before-change="() => validateInfo('imageForm', 'productSeo')"
            >
              <product-image-form
                ref="imageForm"
                @is-loading="(e) => (isLoading = e)"
              />
            </tab-content>

            <tab-content
              title="سئو"
              icon="fab fa-searchengin"
              :before-change="() => validateInfo('productSeo')"
            >
              <product-seo
                ref="productSeo"
                @is-loading="(e) => (isLoading = e)"
              />
            </tab-content>
          </form-wizard>
        </div>
      </bita-ibox>
    </div>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import ProductInfoForm from "./components/ProductInfoForm";
import ProductImageForm from "./components/ProductImagesForm";
// import ProductPricesForm from "./components/ProductCombinationPricesForm";
import ProductVariants from "./components/ProductVariants";
import ProductSeo from "./components/ProductSeo";

export default {
  components: {
    FormWizard,
    TabContent,
    ProductInfoForm,
    ProductImageForm,
    ProductVariants,
    ProductSeo,
  },
  data() {
    return {
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "فروشگاه", link: "" },
        { title: "مدیریت محصولات", link: "/shop/products" },
        {
          title: "ایجاد محصول جدید",
          link: "/shop/products/create",
          active: true,
        },
      ],
      createdProduct: {},
      isLoading: false,
    };
  },
  mounted() {},
  methods: {
    validateInfo(_ref, _nextRef) {
      return new Promise((resolve, reject) => {
        this.$refs[_ref]
          .save()
          .then((res) => {
            this.$flog.success("WIZARD MOVE:", _ref, "TO", _nextRef);
            this.setInitials(_nextRef);
            resolve(true);
          })
          .catch((err) => {
            this.$flog.error("WIZARD MOVE FAILED:", _ref, "TO", _nextRef);
            reject(false);
          });
      });
    },

    setInitials(_ref) {
      switch (_ref) {
        case "detailForm":
          this.$refs.detailForm.setInitialValue(this.createdProduct);
          break;
        case "variantsForm":
          this.$refs.variantsForm.setInitialValue(this.createdProduct);
          break;
        case "imageForm":
          this.$refs.imageForm.setInitialValue(this.createdProduct);
          break;
        case "productSeo":
          this.$refs.productSeo.setInitialValue(this.createdProduct);
          break;
        default:
          break;
      }
    },
    onComplete() {
      this.createdProduct = {};
      let refsToReset = [
        "wizard",
        "infoForm",
        "variantsForm",
        "imageForm",
        "productSeo",
      ];
      for (let toreset of refsToReset) {
        if (this.$refs[toreset]) this.$refs[toreset].reset();
      }
    },
  },
};
</script>
<style>
.vue-form-wizard .wizard-progress-bar {
  float: right;
}

.vue-form-wizard .wizard-card-footer .wizard-footer-left {
  float: right;
}

.vue-form-wizard .wizard-card-footer .wizard-footer-right {
  float: left;
}

.vue-form-wizard .wizard-icon {
  height: inherit;
}
</style>
